<div class="pointer-events-none payment-reason">
  <form [formGroup]="paymentReasonForm">
    <finxone-select-dropdown
      *ngIf="dataIn.attri['enableReasonCategory']"
      id="payment-reason-category"
      [formControlName]="'paymentReasonCategory'"
      [selectedOption]="selectedCategoryText?.description ?? reasonCategoryLabel"
      [options]="paymentReasonCategories"
      [optionLabelKey]="'description'"
      [optionValueKey]="'id'"
      [appendToBody]="true"
      [label]="reasonCategoryLabel"
      (selectionChange)="onCategoryValueChange()"
    ></finxone-select-dropdown>

    <finxone-select-dropdown
      [formControlName]="inputFieldKey"
      id="payment-reason"
      [selectedOption]="selectedText?.description ?? inputLabel"
      [options]="transferReasons"
      [optionLabelKey]="'description'"
      [optionValueKey]="'id'"
      [appendToBody]="true"
      [label]="inputLabel"
      (selectionChange)="onValueChange()"
      [customNoOptionsTemplate]="noOptionsTpl"
    >
    </finxone-select-dropdown>
    <ng-template #noOptionsTpl>
      <div class="dropdown-option">Select a category to see a list of reasons</div>
    </ng-template>
  </form>
</div>
